import RecentlyCoupledTable from "../../features/terminals/components/Recently-Coupled-Table/RecentlyCoupledTable";

export default function TerminalsPage() {
  return (
    <div>
      <RecentlyCoupledTable />
    </div>
  );
}
